import React, { useState } from 'react'
import { withStyles, FormLabel, FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import SelectCPV from 'components/popup/selectCpv/SelectCPV';
import getObjectValue from 'libs/getObjectValue';
import Chip from './Chip';
import removeFormikListElement from 'libs/removeFormikListElement';

const style = theme => ({
	root: {
		marginTop: theme.spacing()
	},
	chipLabel: {
		maxWidth: 250,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	buttonSelect: {
		marginRight: theme.spacing(2)
	}
})

function CPVInput({
	classes,
	formikProps,
	id,
	required,
	disabled,
	label=Tr('cpv_code'),
	skipCheckTouched
}) {

	const [openSelectCPV, setOpenSelectCPV] = useState(false)

	const handleClick = () => {
		setOpenSelectCPV(true)
		formikProps.setFieldTouched(id, true)
	}

	const handleClosePoup = () => {
		setOpenSelectCPV(false)
		formikProps.setFieldTouched(id, true)
	}

	const handleConfirm = (values) => {
		const elements = Object.keys(values).reduce((prevValue, currValue) => {
			if (!values[currValue]) return prevValue;
			return [
				...prevValue,
				JSON.parse(currValue)
			]
		}, [])
		handleClosePoup();
		formikProps.setFieldValue(id, elements)
	}

	const elements = getObjectValue(id, formikProps.values, [])
	const errorValue = getObjectValue(id, formikProps.errors, '')
	const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched)
	const editable = getObjectValue('_editable', formikProps.values, true);
	const errorLabel = touched && errorValue ? errorValue : ' '


	const handleDelete = (index) => {
		removeFormikListElement(formikProps, id, index)
	}

	return (
		<div data-id={id}>
			<FormLabel>
				{label} {required && '*'}
			</FormLabel>
			<GridBlock
				className={classes.root}
				alignItems='center'
				wrap='nowrap'
			>
				{editable && !disabled && <Button
					onClick={handleClick}
					className={classes.buttonSelect}
					disabled={!editable || disabled}
				>
					{Tr('select')}
				</Button>}

				<GridBlock spacing={1}>
					{elements.map((item, i) => {
						return <Chip
							labelClassName={classes.chipLabel}
							key={i}
							value={`${item.publicCode} ${item.name}`}
							onDelete={editable && !disabled ? () => handleDelete(i) : undefined}
						/>
					})}
				</GridBlock>

			</GridBlock>
			<SelectCPV
				initValues={elements}
				open={openSelectCPV}
				onCancel={handleClosePoup}
				onConfirm={handleConfirm}
				label={label}
				multiple
			/>
			<FormHelperText error>{errorLabel}</FormHelperText>
		</div>
	)
}

CPVInput.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(CPVInput);